export default __webpack_public_path__ + "static/media/20.b3304bf0.mp3";